export const breadcrumbs = {
  root: {
    name: '/',
    displayName: 'breadcrumbs.home'
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard'
    },
    {
      name: 'all-customers',
      displayName: 'menu.customers',
      children: [
        {
          name: 'customer-create',
          displayName: 'menu.create'
        }
      ]
    },
    {
      name: 'all-extensions',
      displayName: 'menu.extensions',
      children: [
        {
          name: 'extension-create',
          displayName: 'menu.create'
        },
        {
          name: 'extension-update',
          displayName: 'menu.update'
        }
      ]
    },
    {
      name: 'reporting',
      displayName: 'menu.reporting.title',
      disabled: true,
      children: [
        {
          name: 'call-reporting',
          displayName: 'menu.reporting.call-reporting'
        }
      ]
    },
    {
      name: 'conference-bridge',
      displayName: 'menu.conferenceBridge.title',
      children: [
        {
          name: 'callflow',
          displayName: 'menu.conferenceBridge.callflow'
        }
      ]
    },
    {
      name: 'inno-support',
      displayName: 'Go-support.title',
      disabled: true
      // children: [
      //   {
      //     name: 'call-reporting',
      //     displayName: 'menu.reporting.call-reporting'
      //   }
      // ]
    },
    {
      name: 'all-packages',
      displayName: 'menu.packages'
    },
    {
      name: 'all-invoices',
      displayName: 'menu.billing.invoices'
    },
    {
      name: 'billing',
      displayName: 'menu.billing_account',
      disabled: true,
      children: [
        {
          name: 'billing-rates',
          displayName: 'menu.billing.rates'
        },
        {
          name: 'billing-refill',
          displayName: 'menu.billing.refill'
        },
        {
          name: 'billing-payments',
          displayName: 'menu.billing.payments'
        },
        {
          name: 'billing-charges',
          displayName: 'menu.billing.charges'
        },
        {
          name: 'billing-invoices',
          displayName: 'menu.billing.invoices'
        }
      ]
    },
    {
      name: 'usage',
      displayName: 'menu.billing.usage-title',
      disabled: true,
      children: [
        {
          name: 'billing-summary',
          displayName: 'menu.billing.summary'
        },
        {
          name: 'billing-detailed',
          displayName: 'menu.billing.detailed'
        }
      ]
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      disabled: true,
      children: [
        {
          name: 'customer-settings',
          displayName: 'customer.settings'
        },
        {
          name: 'customer-create-field',
          displayName: 'menu.create_field'
        },
        {
          name: 'crm-integrate',
          displayName: 'crm.integrate_title'
        }
      ]
    }
  ]
}
